var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.549 0C38.465 0 49 11.4096 49 24.4632C49 39.6024 36.652 49 24.5 49C20.482 49 16.023 47.9204 12.446 45.8102C11.1965 45.0496 10.143 44.4852 8.7955 44.9269L3.8465 46.3991C2.597 46.7917 1.47 45.8102 1.8375 44.4852L3.479 38.989C3.7485 38.2283 3.6995 37.4186 3.3075 36.7807C1.2005 32.9039 0 28.659 0 24.5368C0 11.6304 10.3145 0 24.549 0ZM35.7455 21.4206C34.006 21.4206 32.6095 22.8192 32.6095 24.5613C32.6095 26.2789 34.006 27.7021 35.7455 27.7021C37.485 27.7021 38.8815 26.2789 38.8815 24.5613C38.8815 22.8192 37.485 21.4206 35.7455 21.4206ZM24.451 21.4206C22.736 21.3961 21.315 22.8192 21.315 24.5368C21.315 26.2789 22.7115 27.6775 24.451 27.7021C26.1905 27.7021 27.587 26.2789 27.587 24.5613C27.587 22.8192 26.1905 21.4206 24.451 21.4206ZM13.1565 21.4206C11.417 21.4206 10.0205 22.8192 10.0205 24.5613C10.0205 26.2789 11.4415 27.7021 13.1565 27.7021C14.896 27.6775 16.2925 26.2789 16.2925 24.5613C16.2925 22.8192 14.896 21.4206 13.1565 21.4206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b4eb366da22b5e8dc9b67b1942b63e09.svg";
export { ForwardRef as ReactComponent };